// extracted by mini-css-extract-plugin
module.exports = {"title":"PartnersBanner_title__3fExo","partnersWrapper":"PartnersBanner_partnersWrapper__1yc5-","logoWrapper":"PartnersBanner_logoWrapper__1699-"};